// ---------------------------------------------------------------------------------------------------------------
//
import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';

import { OAuthService, AuthConfig } from 'angular-oauth2-oidc';

import { Configuration } from '../../models/app/Configuration.type';

@Injectable()
export class ConfigurationService {

    private readonly configUrlPath: string = 'Home/Config';
    private configData: Configuration;
    private authConfig: AuthConfig;

    get config(): Configuration {
        return this.configData;
    }

    // ---------------------------------------------------------------------------------------------------------------
    constructor(
        private http: HttpClient,
        @Inject('BASE_URL')
        private originUrl: string,
        private oauthService: OAuthService) {
    }


    // ---------------------------------------------------------------------------------------------------------------
    // .
    initialise(): Promise<Configuration> {

        return new Promise<Configuration>((resolve, reject) => {

            this.http.get<Configuration>(`${this.originUrl}${this.configUrlPath}`)

                .subscribe((response: Configuration) => {

                    // API response is not a "propper" config object, so we need to instantiate one
                    // "the right way" here to ensure that the methods are set up nicely on it :)
                    this.configData = new Configuration(response);

                    this.authConfig = {
                        issuer: this.configData.authenticationEndpoint,
                        redirectUri: this.configData.authenticationLoginRedirectUri,
                        postLogoutRedirectUri: this.configData.authenticationLogoutRedirectUri,
                        clientId: this.configData.authenticationClientId,
                        oidc: true,
                        requireHttps: true,
                        showDebugInformation: true,
                        responseType: 'code',
                        scope: 'openid profile roles offline_access groups permissions UploadWebApi MapperWebApi RunnerWebApi ReporterWebApi ' +
                            'DistributorWebApi AutomationWebApi AnalyticsWebApi UserProfileSvc',
                        silentRefreshRedirectUri: window.location.origin + '/silent-refresh.html'
                    };

                    this.oauthService.configure(this.authConfig);

                    this.oauthService.setupAutomaticSilentRefresh();

                    this.oauthService.loadDiscoveryDocumentAndTryLogin()
                        .then(doc => {
                            if (this.oauthService.hasValidAccessToken()) {
                                this.oauthService.loadUserProfile();
                                return resolve(this.configData);
                            } else {
                                this.oauthService.initLoginFlow();
                            }
                        });

                }, (err: HttpErrorResponse) => {
                    console.error("Failed to initialise configuration - " + err.message + " - " + err.statusText);

                    return reject(err);
                });
        });
    }
}